import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Droplets,
  Video,
  Building2,
  Bath,
  Siren,
  Wrench,
  ArrowUpRight,
} from "lucide-react";

const teaserServices = [
  { icon: Droplets, label: "Drain Cleaning & Unblocking", speciality: true },
  { icon: Video, label: "CCTV Drainage Surveys" },
  { icon: Building2, label: "Commercial & Project Work" },
  { icon: Bath, label: "Bathroom Installations" },
  { icon: Siren, label: "Emergency Call-Outs" },
  { icon: Wrench, label: "General Plumbing Repairs" },
];

const ServicesTeaser = () => {
  return (
    <section className="relative py-20 md:py-28 bg-[#0B132B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4">
              / 01 — Services
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95] tracking-tight">
              EVERY JOB.
              <br />
              <span className="text-[#D47A4A]">DONE RIGHT.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#A0ABC0] max-w-md">
              From a dripping tap at midnight to a full bathroom install — we
              cover the full scope of domestic and commercial plumbing and
              drainage across Edinburgh.
            </p>
            <Link
              to="/services"
              data-testid="home-services-view-more"
              className="group inline-flex items-center gap-2 mt-8 bg-[#D47A4A] hover:bg-[#B85D2A] text-[#0B132B] font-bold px-6 py-3 rounded-md transition-all uppercase tracking-wider text-sm shadow-md shadow-[#D47A4A]/20 hover:shadow-[#D47A4A]/40 hover:-translate-y-0.5"
            >
              View All Services
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {teaserServices.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.45, delay: i * 0.05 }}
                  className={`relative flex items-center gap-4 p-4 md:p-5 rounded-md border bg-[#151D33] transition-colors ${
                    s.speciality
                      ? "border-[#D47A4A]/60"
                      : "border-[#2C374D] hover:border-[#D47A4A]/50"
                  }`}
                >
                  <div className="w-10 h-10 flex items-center justify-center border border-[#2C374D] bg-[#0B132B] rounded-md">
                    <Icon className="w-5 h-5 text-[#D47A4A]" />
                  </div>
                  <p className="font-display text-base md:text-lg text-white tracking-wide">
                    {s.label.toUpperCase()}
                  </p>
                  {s.speciality && (
                    <span className="absolute -top-2.5 right-3 bg-[#D47A4A] text-[#0B132B] text-[10px] font-bold uppercase tracking-[0.18em] px-2 py-0.5 rounded-md">
                      Speciality
                    </span>
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesTeaser;
